import React, { Component } from "react";
import { connect } from "react-redux";
import GenerateDataSheet from "./generateDataSheet";
import { formDigCode } from "../common/formDigCode";

class Selected extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadMeasuring: false,
      showText: false,
      showPreSelected: false,
      orderCode: ""
    };
  }

  formActualOrderCode(propValue) {
    var oCode;
    oCode =
      "3.TI." +
      (propValue.winchType.orderCode ? propValue.winchType.orderCode : "") +
      "." +
      (propValue.drumWidth.orderCode ? propValue.drumWidth.orderCode : "") +
      "." +
      (propValue.drumSurface.orderCode ? propValue.drumSurface.orderCode : "") +
      "." +
      (propValue.motorType.orderCode ? propValue.motorType.orderCode : "") +
      "." +
      (propValue.rotationDirection.orderCode
        ? propValue.rotationDirection.orderCode
        : "") +
      "." +
      (propValue.motorLayout.orderCode ? propValue.motorLayout.orderCode : "") +
      "." +
      (propValue.ropeEndControl.orderCode !== "00"
        ? propValue.ropeEndControl.orderCode
        : propValue.pressureRoller.orderCode) +
      "." +
      (propValue.loadMeasuring.orderCode
        ? propValue.loadMeasuring.orderCode
        : "") +
      "." +
      (propValue.paintFinish.orderCode ? propValue.paintFinish.orderCode : "") +
      "." +
      (propValue.wireRope.orderCode ? propValue.wireRope.orderCode : "") +
      "." +
      formDigCode(propValue) +
      ".";
    return oCode;
  }

  componentDidUpdate(previousProps) {
    if (previousProps !== this.props) {
      this.setState({
        orderCode: this.formActualOrderCode(this.props)
      });
      if (this.props.mType === previousProps.mType) {
        this.setState({
          showPreSelected: true
        });
      }
      if (this.props.mType === "metric") {
        this.setState({
          loadMeasuring: true
        });
      }
      if (
        this.props.ropeEndControl.orderCode === "15" &&
        this.props.fasteners.orderCode === "1" &&
        this.props.externalBrakeRelease.orderCode === "1" &&
        this.props.throttleValve.orderCode === "1"
      ) {
        this.setState({
          showText: true
        });
      } else {
        this.setState({
          showText: false
        });
      }
    }
  }

  render() {
    return (
      <div className="selected-container">
        <div className="flex header-selected">
          <div>
            <span>Selected - </span> {this.props.winchType.name}
          </div>
           
        </div>
        <div className="selected-body">
          {this.props.winchType && (
            <div className="winch-img">
              <img
                className="winch_img"
                src={this.props.winchType.img}
                alt={"winch" + this.props.winchType.name}
              />
            </div>
          )}
          <div className="row">
            <div className="col-md-5">Winch type:</div>
            {this.props.winchType.name && (
              <div className="col-md-7">
                {this.props.winchType.name},{" "}
                <span>{this.props.winchType.hoistingForce}</span> hoisting force
              </div>
            )}
          </div>
          <hr />
          <DisplaySelected
            selected={{
              name: "Drum width",
              value:
                this.props.drumWidth !== ""
                  ? this.props.drumWidth.value + " " + this.props.drumWidth.unit
                  : ""
            }}
          />
          <hr />
          <DisplaySelected
            selected={{
              name: "Drum surface",
              value: this.state.showPreSelected
                ? this.props.drumSurface.value
                : ""
            }}
          />
          <hr />
          <div className="row">
            <div className="col-md-5">Motor type and displacement</div>
            {this.props.motorType.name && (
              <div className="col-md-7">
                {this.props.motorType.name}
                <br />
                <span>
                  Hoisting force{" "}
                  {(this.props.motorType.hoistingForce.name
                    ? this.props.motorType.hoistingForce.name
                    : this.props.motorType.hoistingForce.value) +
                    " " +
                    this.props.motorType.hoistingForce.unit}{" "}
                  at hydraulic pressure{" "}
                  {(this.props.motorType.hydraulicPressure.enteredValue
                    ? this.props.motorType.hydraulicPressure.enteredValue
                    : this.props.motorType.hydraulicPressure.value) +
                    " " +
                    this.props.motorType.hydraulicPressure.unit}
                </span>
                <br />
                <span>
                  Rope speed{" "}
                  {(this.props.motorType.ropeSpeed.calculatedRopeSpeed
                    ? this.props.motorType.ropeSpeed.calculatedRopeSpeed
                    : this.props.motorType.ropeSpeed.value) +
                    " " +
                    this.props.motorType.ropeSpeed.unit}{" "}
                  at oil flow{" "}
                  {(this.props.motorType.oilFlow.enteredValue
                    ? this.props.motorType.oilFlow.enteredValue
                    : this.props.motorType.oilFlow.value) +
                    " " +
                    this.props.motorType.oilFlow.unit}
                </span>
              </div>
            )}
          </div>
          <hr />
          <div className="row">
            <div className="col-md-5">
              Rotation direction and general layout
            </div>
            {this.props.rotationDirection.value && (
              <div className="col-md-7">
                {this.props.rotationDirection.value}
                <br />
              </div>
            )}
          </div>
          <hr />
          <div className="row">
            <div className="col-md-5">Motor layout</div>
            {this.props.motorLayout.value && (
              <div className="col-md-7">
                {this.props.motorLayout.value}
                <br />
              </div>
            )}
          </div>
          <hr />
          <DisplaySelected
            selected={{
              name: "Pressure roller",
              value: this.props.pressureRoller.value
            }}
          />
          <hr />
          <DisplaySelected
            selected={{
              name: "Rope end control",
              value: this.props.ropeEndControl.value
            }}
          />
          <hr />
          {this.state.loadMeasuring &&
            this.props.loadMeasuring.orderCode !== "00" && (
              <div>
                <div className="row">
                  <div className="col-md-5">Load measuring:</div>

                  <div className="col-md-7">
                    {this.props.loadMeasuring.main.value}, <br />{" "}
                    {this.props.loadMeasuring.sub.value}
                  </div>
                </div>
                <hr />
              </div>
            )}
          {this.props.loadMeasuring.orderCode === "00" && (
            <div>
              <div className="row">
                <div className="col-md-5">Load measuring:</div>

                <div className="col-md-7">
                  {this.props.loadMeasuring.value} <br />{" "}
                </div>
              </div>
              <hr />
            </div>
          )}

          <DisplaySelected
            selected={{
              name: "Paint finish",
              value: this.props.paintFinish.value
            }}
          />
          <hr />
          <DisplaySelected
            selected={{ name: "Wire rope", value: this.props.wireRope.value }}
          />
          {this.props.wireRope.orderCode !== "00" && (
            <div className="row">
              <div className="col-md-5" />
              <div className="col-md-7">
                The minimum breaking force of the rope is{" "}
                {this.props.wireRope.mbf}
              </div>
            </div>
          )}

          <hr />
          <DisplaySelected
            selected={{ name: "Fasteners", value: this.props.fasteners.value }}
          />
          <hr />
          <DisplaySelected
            selected={{
              name: "Emergency brake release",
              value: this.props.externalBrakeRelease.value
            }}
          />
          <hr />
          <DisplaySelected
            selected={{
              name: "Brake test valve",
              value: this.props.throttleValve.value
            }}
          />
          <hr />
          {this.props.winchType.orderCode && (
            <div className="row ma-20 pt-10">
              <div className="col-md-5">Order code:</div>
              <div className="col-md-7">{this.state.orderCode}</div>
            </div>
          )}
          {/* {this.state.showText && (
            <p className="api2c">
              {this.props.winchType.name} is suitable for API 2C certified
              devices.
            </p>
          )} */}
        </div>
        <GenerateDataSheet api2c={this.state.showText} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    winchType: state.winchType,
    mType: state.mType,
    drumWidth: state.drumWidth,
    drumSurface: state.drumSurface,
    motorType: state.motorType,
    rotationDirection: state.rotationDirection,
    motorLayout: state.motorLayout,
    pressureRoller: state.pressureRoller,
    ropeEndControl: state.ropeEndControl,
    loadMeasuring: state.loadMeasuring,
    paintFinish: state.paintFinish,
    wireRope: state.wireRope,
    fasteners: state.fasteners,
    externalBrakeRelease: state.externalBrakeRelease,
    throttleValve: state.throttleValve
  };
};

class DisplaySelected extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-md-5">{this.props.selected.name}:</div>
        <div className="col-md-7">{this.props.selected.value}</div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Selected);



// WEBPACK FOOTER //
// ./src/components/selected.js